<template>
    <div ref="textReadingViewWrapper" class="textReading-view">
        <div class="controls">
            <div>
                <div>
                    <!-- <button @click="setFontSize('INC')">A<sup>+</sup></button>
                    <button @click="setFontSize('DEC')">A<sup>-</sup></button> -->
                </div>
                <div>
                  <button @click="goprint">打印</button>
                  <button @click="closeWindow">关闭</button>   
                </div>
            </div>
        </div>
        <div class="textReading-body-wrapper">
            <div class="textReading-body">
                <div class="body-main-mask">
                    <div class="article-mask">
                        <h5 class="article-title" v-html="articleData.Title">
                           
                        </h5>
                        <div v-show="baseInfo && articleData.Content" class="base-infos">
                            <span>{{ articleAuthor }}</span>
                        </div>
                        <div class="article-content-bindDom" v-html="articleData.Content" :style="{fontSize:currentFontSize+'px'}"/>
                        <div :style="{color: themeColor}" v-if="canread && isThemeLibrary()" @click="showLoginRegister"> {{ langTransfer('阅读全文') }}</div>
                        <div v-show="isPending"
                             class="loader">
                            <svg id="Layer_1"
                                 version="1.1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"
                                 x="0px"
                                 y="0px"
                                 width="48px"
                                 height="60px"
                                 viewBox="0 0 24 30"
                                 style="enable-background:new 0 0 50 50;"
                                 xml:space="preserve">
                                <rect :fill="themeColor"
                                      x="0"
                                      y="10"
                                      width="4"
                                      height="10"
                                      opacity="0.2">
                                    <animate attributeName="opacity"
                                             attributeType="XML"
                                             values="0.2; 1; .2"
                                             begin="0s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="height"
                                             attributeType="XML"
                                             values="10; 20; 10"
                                             begin="0s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="y"
                                             attributeType="XML"
                                             values="10; 5; 10"
                                             begin="0s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                </rect>
                                <rect :fill="themeColor"
                                      x="8"
                                      y="10"
                                      width="4"
                                      height="10"
                                      opacity="0.2">
                                    <animate attributeName="opacity"
                                             attributeType="XML"
                                             values="0.2; 1; .2"
                                             begin="0.15s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="height"
                                             attributeType="XML"
                                             values="10; 20; 10"
                                             begin="0.15s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="y"
                                             attributeType="XML"
                                             values="10; 5; 10"
                                             begin="0.15s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                </rect>
                                <rect :fill="themeColor"
                                      x="16"
                                      y="10"
                                      width="4"
                                      height="10"
                                      opacity="0.2">
                                    <animate attributeName="opacity"
                                             attributeType="XML"
                                             values="0.2; 1; .2"
                                             begin="0.3s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="height"
                                             attributeType="XML"
                                             values="10; 20; 10"
                                             begin="0.3s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                    <animate attributeName="y"
                                             attributeType="XML"
                                             values="10; 5; 10"
                                             begin="0.3s"
                                             dur="0.6s"
                                             repeatCount="indefinite" />
                                </rect>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import Footer from '@/components/footer'
    import backBtn from '@/components/backBtn'
    export default {
        components: {
            Footer,backBtn
        },
        data () {
            return {
                textReadingBScroll: null,
                catelogBodyBScroll: null,
                catelogMaskPosY: 0,
                articleData: {},
                baseInfo: {},
                catelogList: [],
                viewHeight: 0,
                lastParams: {},
                collectionId: undefined,
                isPending: false,
                canread:false,
                currentFontSize:18
            }
        },
        computed: {
            catelogListHeight () {
                const { viewHeight } = this
                return viewHeight - 300
            },
            catelogHeaderText () {
                const { baseInfo } = this
                if (baseInfo.Year !== undefined) {
                    return '期刊目录'
                }

                if (baseInfo.PublishName !== undefined) {
                    return '图书目录'
                }
                if (baseInfo.PubDate !== undefined) {
                    return '报纸目录'
                }
                return '目录'
            },
            articleAuthor () {
                const { articleData, baseInfo } = this
                if (baseInfo.Year !== undefined) {
                    return articleData.Author ? `作者：${ articleData.Author }` : '作者：佚名'
                }

                if (baseInfo.PublishName !== undefined) {
                    return baseInfo.Author ? `作者：${ baseInfo.Author }` : '作者：佚名'
                }
                return '作者：佚名'
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            isNexus () {
                return this.$store.state.isNexus
            }
        },
        mounted () {   
            document.getElementsByClassName('global-header')[0].style.display = 'none';
            document.getElementsByClassName('routerView-wrapper')[0].style.top = '0'     
        },
        methods: {
            closeWindow()
            {
                window.close();
            },
            setFontSize(type)
            {
                if(type=='INC' && this.currentFontSize<24) this.currentFontSize++;
                if(type=='DEC' && this.currentFontSize>12) this.currentFontSize--;
            },
            goprint()
            {
                window.print();
            },
            showLoginRegister () {
                this.$store.commit('setShowLoginRegister', true)
            },
            isThemeLibrary()
            {
               return this.$route.name.substring(0,5)=='theme'?true:false;
            },
            setCurrentLibraryInfo(params)
            {
                this.$store.commit('setThemeCurrentSelectCategory',{Name:params.secondCateName,Code:params.secondCateId});
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 132,
                    height: 132,
                    text
                })
            },
            async getShortQCUrl (shortCode) {
                try {
                    const data = await this.$apis('shortQC').getShortQCUrl(shortCode)
                    if (data) {
                        this.initQrCode(data)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getNewspaperQrUrl(id,year)
            {
                try {   
                    const data = await this.$apis('shortQC').getNewspaperQrUrl(id,year)          
                    this.initQrCode(data)
                } catch (error) {
                    console.log(error)
                }
            },
            async getArticle (params) {
                try {
                    this.isPending = true
                    let { resourceType, id, articleId,year,issue,token} = params;
                    if(resourceType=="book" && this.isThemeLibrary())
                    {
                        year = true;
                    }
                    /*const { Data } = await this.$apis(resourceType).getArticle(articleId, id,year,issue);*/

                    let d  = {};
                    if(token.toLowerCase()!='token'){
                        d = await this.$apis(resourceType).getArticle(articleId,token);
                    }else{
                        d = await this.$apis(resourceType).getArticle(articleId,id,year,issue);
                    }

                    this.articleData = d.Data
                    this.isPending = false
                    
                } catch (error) {
                    const { Code } = error

                    if (Code === 4) {
                       let loginurldata = await this.$apis('user').getloginurl();
                        this.$store.commit('setUserLoginUrl',loginurldata.Data);
                        this.$store.commit('setShowLoginRegister', true)
                    }
                    this.$tools.checkBindMobile(Code);
                    if(this.isThemeLibrary()){
                        this.articleData = error.Data;
                        this.canread = true;
                    }
                    this.isPending = false
                    console.log(error)
                }
            },
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams) && vm.articleData.Content) {
                    //return
                }
                vm.canread =false;
                vm.lastParams = params
                vm.articleData = {}
                vm.baseInfo = {}
                vm.catelogList = []
                vm.collectionId = undefined
                vm.getArticle(params)
            })
        }
    }
</script>

<style lang="scss" scoped>
    @media print{
        .controls{
            display: none !important
        }
    }
    .textReading-view {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
        &>.controls{
            width: 100%;
            background:#f3f3f3;
            height: 40px;
            &>div{
                margin: 0 auto;
                width: 702px;
                height: 100%;
                line-height:40px;
                display: flex;
                justify-content: space-between;
                &>div{
                    &:first-child{
                        width: 70px;
                        display: flex;
                        justify-content: space-between;
                    }
                    &:last-child{
                        width: 70px;
                        display: flex;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
    .textReading-view-themelibary {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
    }

    .textReading-body-wrapper,.textReading-body-wrapper-themelibrary {
        width: 100%;
        margin: 0 auto;
    }

    .textReading-body-wrapper::before {
        content: "";
        height: 600px;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .textReading-body {
        position: relative;
        width: 1140px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .body-main-mask {
        width: 850px;
        box-sizing: border-box;
        padding: 30px 74px 0 74px;
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .article-mask {
        width: 100%;

        h5 {
            max-height: 100px;
            min-height: 50px;
            
            font-size: 36px;
            color: #1A1A1A;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
        }

        .base-infos {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0 20px;
            height: 22px;

            span {
                
                font-size: 16px;
                color: #ABADB1;
                flex:1
            }

            &>div {
                width: 120px;
                display: flex;
                justify-content: flex-start;
                &>div:first-child{
                    flex: 1;
                    width: 70px;
                    display: flex;
                    justify-content: space-between;
                }
                 &>div:nth-child(2){
                    width: 60px;
                    text-align: center;
                    &>button{
                        font-size: 16px;
                    }
                }
                &>div:last-child{
                    width: 16px;
                    height: 16px;
                    cursor: pointer;                    
                }
            }
        }
    }

    .third-platform-shares {
        height: 36px;
        padding-left: 2px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        opacity: 0;

        img {
            width: 28px;
            height: 28px;
            margin-right: 7px;
            border-radius: 50%;
        }
    }

    .qrcode-catelog-mask {
        width: 270px;
    }

    .info-qcode-mask {
        width: 270px;
        box-sizing: border-box;
        padding: 30px 15px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .cover {
            display: block;
            width: 240px;
            height: 304px;
            border-radius: 4px;
            background: #f6f6f6;
        }

        h5 {
            
            font-size: 20px;
            color: #1A1A1A;
            line-height: 20px;
            margin: 24px 0 8px;
        }

        span {
            
            font-size: 14px;
            color: #8590A6;
            line-height: 14px;
        }

        .qrcode {
            display: block;
            width: 132px;
            height: 132px;
            margin-top: 24px;
            background: #f6f6f6;
        }

    }

    .catelog-mask {
        width: 270px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        margin-top: 20px;
        position:fixed;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            padding-left: 16px;
            border-bottom: 1px solid #F0F2F7;
        }
    }
    .catelog-mask-themelibary {
        width: 270px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        margin-top: 20px;
        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            padding-left: 16px;
            border-bottom: 1px solid #F0F2F7;
        }
    }

    .catelog-body-wrapper {
        width: 100%;
        height: fit-content;
        overflow: hidden;
    }

    .catelog-body {
        width: 100%;
        box-sizing: border-box;
        padding: 8px 0;
    }

    .catelog-item {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        padding: 0 16px;
        
        font-size: 14px;
        color: #1A1A1A;
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }

    .catelog-item:hover {
        background: #F6F6F6;
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: none;
    }

    .loader {
        width: 100%;
        height: 370px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>

<style>
    .article-content-bindDom * {
        max-width: 702px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-indent: 0 !important;
        /*font-size: 18px !important;*/
        color: #363636 !important;
        letter-spacing: 0 !important;
        text-align: justify !important;
        line-height: 32px !important;
        user-select: text !important;
    }

    .article-content-bindDom p {
        text-indent: 2em !important;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .article-content-bindDom h1,
    .article-content-bindDom h2,
    .article-content-bindDom h3,
    .article-content-bindDom h4,
    .article-content-bindDom h5 {
        font-size: 22px !important;
        color: #1E1E1E !important;
        letter-spacing: 0 !important;
        text-align: center !important;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .article-content-bindDom p img {
        margin-left: -2em !important;
    }

    .article-content-bindDom img {
        display: inline-block !important;
    }
    .article-content-bindDom+div{
        text-align: center;
        cursor: pointer;
    }
    .bscroll-vertical-scrollbar {
        z-index: 9 !important;
    }
</style>
